import React, { useEffect, useState } from 'react';
import ReceiptAPI from './ReceiptAPI';
import PointsBankAPI from './PointsBankAPI';
import PointsInventoryAPI from './PointsInventoryAPI';
import './PatientReceipts.css';

const PatientReceipts = ({ patientId }) => {
  const [receipts, setReceipts] = useState([]);
  const [pointsBankId, setPointsBankId] = useState(null);
  const [inventoryMap, setInventoryMap] = useState({});

  const receiptApi = new ReceiptAPI();
  const pointsApi = new PointsBankAPI();
  const inventoryApi = new PointsInventoryAPI();

  useEffect(() => {
    if (patientId) {
      fetchPointsBankId();
      fetchInventoryTitles();
    }
  }, [patientId]);

  const fetchPointsBankId = async () => {
    try {
      const totalPointsInfo = await pointsApi.getTotalPoints(patientId);
      if (totalPointsInfo && totalPointsInfo.id) {
        setPointsBankId(totalPointsInfo.id);
      } else {
        console.error('Could not find points bank ID');
      }
    } catch (error) {
      console.error('Error fetching points bank ID:', error);
    }
  };

  const fetchInventoryTitles = async () => {
    try {
      const inventoryItems = await inventoryApi.getAll();
      const map = {};
      inventoryItems.forEach(item => {
        map[item.inventory_id] = item.title;
      });
      setInventoryMap(map);
    } catch (error) {
      console.error('Error fetching inventory titles:', error);
    }
  };

  useEffect(() => {
    if (pointsBankId) {
      fetchReceipts(pointsBankId);
    }
  }, [pointsBankId]);

  const fetchReceipts = async (pbId) => {
    try {
      const data = await receiptApi.getByPointsBankId(pbId);
      // 🛠 Sort by date descending
      const sorted = [...data].sort((a, b) => new Date(b.date) - new Date(a.date));
      setReceipts(sorted);
    } catch (error) {
      console.error('Failed to fetch patient receipts:', error);
    }
  };

  return (
    <div className="patient-receipts">
      <h1>My Rewards History</h1>

      <div className="receipt-list">
        {receipts.map((receipt) => (
          <div key={receipt.receipt_id} className="receipt-card">
            <h3>{inventoryMap[receipt.inventoryId] || `Item ID: ${receipt.inventoryId}`}</h3>
            <p><strong>Points Used:</strong> {receipt.amountTotal}</p>
            <p><strong>Before:</strong> {receipt.amountBefore} pts</p>
            <p><strong>After:</strong> {receipt.amountAfter} pts</p>
            <p><strong>Date:</strong> {receipt.date}</p>
            <p><strong>Status:</strong> {receipt.vouched ? 'Received ✅' : 'Pending ❌'}</p>
          </div>
        ))}
      </div>
    </div>
  );
};

export default PatientReceipts;
